import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdCarouselComponent } from './cd-carousel.component';

@NgModule({
  exports: [CdCarouselComponent],
  imports: [CommonModule, CdCarouselComponent],
})
export class CdCarouselModule {}
